import { downloadAuthorizedFile } from './downloadBlob'

const endpointFor = (module, bookingId) => {
  if (module === 'hotel') return `/admin/hotel/bookings/${bookingId}/documents/download`
  if (module === 'sarai') return `/admin/sarai/bookings/${bookingId}/documents/download`
  return `/admin/gurudwara-service-booking/${bookingId}/documents/download`
}

export function downloadBookingDocuments ({ module, bookingId }) {
  return downloadAuthorizedFile({
    url: endpointFor(module, bookingId),
    fallbackName: 'booking-documents.zip',
    fallbackError: 'Failed to download documents'
  })
}

export function downloadBookingDocument ({ module, bookingId, documentId }) {
  const base = endpointFor(module, bookingId).replace(/\/download$/, '')
  return downloadAuthorizedFile({
    url: `${base}/${documentId}/download`,
    fallbackName: 'document',
    fallbackError: 'Failed to download this document'
  })
}
